let socket = null;
let messageHandler = null;

// Get WebSocket URL - use current host (through nginx proxy) or fallback to localhost:8000
const getWebSocketUrl = (path) => {
  // If running in browser, use current host (nginx will proxy /ws to FastAPI)
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = window.location.host; // This will be localhost:3000
    return `${protocol}//${host}${path}`;
  }
  // Fallback for non-browser environments
  return `ws://localhost:8000${path}`;
};

export const initSocket = (path = "/ws/control", onMessage) => {
  socket = new WebSocket(getWebSocketUrl(path));

  socket.onopen = () => {
    console.log("WebSocket connected:", path);
  };

  socket.onmessage = (event) => {
    if (onMessage) {
      try {
        const data = JSON.parse(event.data);
        onMessage(data);
      } catch (err) {
        console.error("Invalid JSON:", err);
      }
    }
  };

  socket.onclose = (event) => {
    console.log("WebSocket closed:", event.code);
  };

  socket.onerror = (err) => {
    console.error("WebSocket error:", err);
  };
};

export const sendControl = (command) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify({ command }));
    console.log("Sent:", command);
  } else {
    console.warn("WebSocket not ready");
  }
};

export const sendScreenshot = (dataUrl) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    const payload = {
      type: "screenshot",
      image: dataUrl,
      timestamp: new Date().toISOString()
    };
    socket.send(JSON.stringify(payload));
    console.log("Screenshot sent to backend");
  } else {
    console.error("WebSocket not connected - cannot send screenshot");
  }
};

export const closeSocket = () => {
  if (socket) {
    socket.close();
    socket = null;
  }
};
